/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type IssueCardRequestCardholderInfoDocumentType = typeof IssueCardRequestCardholderInfoDocumentType[keyof typeof IssueCardRequestCardholderInfoDocumentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IssueCardRequestCardholderInfoDocumentType = {
  passport: 'passport',
  'drivers-license': 'drivers-license',
  'national-id': 'national-id',
} as const;
